export const SISTEMA_CAT_OPTIONS = [
  'catB',
  'cat1',
  'cat2',
  'cat3',
  'cat4',
] as const

export const SISTEMA_FUNCTION_TYPE_OPTIONS = [
  'fncInput',
  'fncLogic',
  'fncOutput',
] as const

export const SISTEMA_CHANNEL_TYPE_OPTIONS = ['ch1', 'ch2', 'chTest'] as const

export const SISTEMA_PLR_OPTIONS = ['plA', 'plB', 'plC', 'plD', 'plE'] as const

export const SISTEMA_PLR_DET_OPTIONS = [
  'detDirect',
  'detMeasures',
  'detStandard',
  'detDocument',
] as const

export type SistemaCat = (typeof SISTEMA_CAT_OPTIONS)[number]
export type SistemaFunctionType = (typeof SISTEMA_FUNCTION_TYPE_OPTIONS)[number]
export type SistemaChannelType = (typeof SISTEMA_CHANNEL_TYPE_OPTIONS)[number]
export type SistemaPlr = (typeof SISTEMA_PLR_OPTIONS)[number]
export type SistemaPlrDet = (typeof SISTEMA_PLR_DET_OPTIONS)[number]
